import { FormEvent, useState } from "react"
import { apiFetch } from "../../lib/api"
import { useEmpresa } from "../../app/context/EmpresaContext"

export const IaPage = () => {
  const { empresaId } = useEmpresa()
  const [descricao, setDescricao] = useState("")
  const [sugestoes, setSugestoes] = useState<Array<{ descricao: string; ncm: string; score: number }>>([])
  const [message, setMessage] = useState("")

  const handleSugestao = async (e: FormEvent) => {
    e.preventDefault()
    if (!empresaId) return
    const res = await apiFetch<{ sugestoes: Array<{ descricao: string; ncm: string; score: number }> }>(
      `/v1/empresas/${empresaId}/ia/sugestao-ncm`,
      { method: "POST", body: JSON.stringify({ descricao }) },
    )
    setSugestoes(res.sugestoes)
  }

  const handleCatalogo = async () => {
    if (!empresaId) return
    await apiFetch(`/v1/empresas/${empresaId}/ia/catalogo`, {
      method: "POST",
      body: JSON.stringify({ codigo_interno: "SKU-001", descricao, ncm: "84713012", cfop_padrao: "5102" }),
    })
    setMessage("Item adicionado ao catálogo.")
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">IA — sugestão NCM</h1>
      <form onSubmit={handleSugestao} className="rounded-xl border bg-white p-5 space-y-3">
        <textarea value={descricao} onChange={(e) => setDescricao(e.target.value)} rows={3} placeholder="Descrição do produto" className="w-full rounded-lg border px-3 py-2 text-sm" required />
        <div className="flex gap-2">
          <button type="submit" className="rounded-lg bg-brand-600 px-4 py-2 text-sm text-white">Sugerir NCM</button>
          <button type="button" onClick={handleCatalogo} className="rounded-lg border px-4 py-2 text-sm">Salvar no catálogo</button>
        </div>
      </form>
      {message && <p className="text-sm">{message}</p>}
      <ul className="rounded-xl border bg-white divide-y">
        {sugestoes.map((s, i) => (
          <li key={i} className="px-5 py-3 text-sm">{s.descricao} — NCM {s.ncm} (score {(s.score * 100).toFixed(0)}%)</li>
        ))}
      </ul>
    </div>
  )
}
